module.exports = __webpack_public_path__ + "static/media/messages.c42c4270.svg";